import * as React from "react";

const ShopIcon = (props) => (
<svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height} {...props} data-ga4={props.isPwa ? "App: Nav Bar - Shop" : ""}>
    <title>{"Shop"}</title>
    <g
      fill="none"
      fillRule="evenodd"
      stroke={props.stroke}
      strokeLinecap="round"
      strokeWidth={1.2}
    >
      <path d="M1 1.577h15.754M1 8.5h15.754M1 15.423h15.754" />
    </g>
  </svg>
);

export default ShopIcon;
